import styled from '@emotion/styled';

import { TooltipArrow } from './components/TooltipArrow';
import { CloseIcon } from './components/CloseIcon';

export const Arrow = styled(TooltipArrow)`
  display: flex;
  fill: ${({ theme }) => theme.palette.colors.primary};
`;

export const Root = styled.div<{ visible: boolean; arrowCornerPadding: number }>`
  z-index: 1;
  max-width: 388px;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  transition: opacity 0.3s ease 0s;
  border: 0 solid #004b54;
  border-radius: 2px;

  &[data-popper-placement*='top'] {
    & ${Arrow} {
      bottom: calc(-1 * var(--arrow-narrow-size) + var(--border-width));
    }
  }

  &[data-popper-placement*='bottom'] {
    & ${Arrow} {
      top: calc(-1 * var(--arrow-narrow-size) + var(--border-width));
    }

    & ${Arrow} svg {
      transform: rotate(180deg);
    }
  }

  &[data-popper-placement*='right'] {
    & ${Arrow} {
      right: auto;
      left: var(--border-width);
    }

    & ${Arrow} svg {
      transform: rotate(90deg);
      transform-origin: 3px -3px;
    }
  }

  &[data-popper-placement*='left'] {
    & ${Arrow} {
      left: auto;
      right: calc(-1 * var(--arrow-narrow-size) + var(--border-width));
    }

    & ${Arrow} svg {
      transform: rotate(-90deg);
      transform-origin: 14px 4px;
    }
  }

  &[data-popper-placement*='top'][data-popper-placement*='top-end'],
  &[data-popper-placement*='bottom'][data-popper-placement*='bottom-end'] {
    & ${Arrow} {
      left: ${({ arrowCornerPadding }) => `-${arrowCornerPadding}px`} !important;
    }
  }

  &[data-popper-placement*='top'][data-popper-placement*='top-start'],
  &[data-popper-placement*='bottom'][data-popper-placement*='bottom-start'] {
    & ${Arrow} {
      left: ${({ arrowCornerPadding }) => `-${arrowCornerPadding}px`} !important;
    }
  }

  // Tooltip max width plus paddings
  @media (max-width: 420px) {
    max-width: calc(100% - 32px);
  }

  --border-width: 1px;
  --arrow-narrow-size: 14px;
`;

export const View = styled.div<{ variant: 'primary' | 'outline' }>`
  position: relative;
  max-width: 387px;
  padding: 8px 48px 8px 12px;
  border: var(--border-width) solid ${({ theme }) => theme.palette.colors.primary};
  border-radius: 2px;
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme, variant }) => (variant === 'primary' ? '#fff' : theme.palette.colors.primary)};
  background-color: ${({ theme, variant }) =>
    variant === 'primary' ? theme.palette.colors.primary : '#fff'};
  box-shadow: rgba(0, 0, 0, 10%) 5px 5px 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    max-width: 300px;
  }
`;

export const CloseButton = styled(CloseIcon)<{ variant: 'primary' | 'outline' }>`
  cursor: pointer;
  position: absolute;
  top: 13px;
  right: 13px;
  width: 14px;
  height: 14px;
  min-height: auto;
  color: ${({ theme, variant }) => (variant === 'primary' ? '#fff' : theme.palette.colors.primary)};
`;

export const FakeButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-shadow: none;
  min-width: auto;
  outline: none !important;
`;
